import { memo } from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import TextIcon from '@mui/icons-material/TextFieldsOutlined';
import DateIcon from '@mui/icons-material/CalendarToday';
import GestureIcon from '@mui/icons-material/Gesture';
import _omit from 'lodash/omit';
//Local files
import ElementWrapper from 'components/Documents/Builder/Element/Common/ElementWrapper/ElementWrapper';
import DateDrawer from 'components/Documents/Builder/Drawers/Date/Date';
import TextDrawer from 'components/Documents/Builder/Drawers/Text/Text';
import Signature from 'components/Documents/Builder/Drawers/Signature/Signature';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';

const Element = ({ 
  id, zoom = 1, x, y, width, height, bounds, pageSize, elementable_type, elementable = null, 
  activeElementId, onTransform, onChangeElementable, onDelete, onActiveElement
}) => {

  const elementProps = {
    date_element: {
      additional: null,
      Drawer: DateDrawer,
      text: <Typography variant='subtitle2' sx={{ fontStyle: 'italic' }}>Date Signed{elementable?.required && <Box component='span' sx={{color: 'error.main'}}>*</Box>}</Typography>,
      icon: <DateIcon />
    },
    text_element: {
      additional: null,
      Drawer: TextDrawer,
      text: <Typography variant='subtitle2' sx={{ fontStyle: 'italic' }}>Text{elementable?.required && <Box component='span' sx={{color: 'error.main'}}>*</Box>}</Typography>,
      icon: <TextIcon />
    },
    signature_element: {
      additional: null,
      Drawer: Signature,
      text: <Typography variant='subtitle2' sx={{ fontStyle: 'italic' }}>Signature{elementable?.required && <Box component='span' sx={{color: 'error.main'}}>*</Box>}</Typography>,
      icon: <GestureIcon />
    }
  };

  const handleClick = () => {
    onActiveElement(id)
  }

  return (
    <>
      <ElementWrapper
        position={{ x: x*zoom, y: y*zoom }}
        size={{ width: width*zoom, height: height*zoom }}
        active={activeElementId === id}
        onClick={handleClick}
        drawerProps={{ open: activeElementId === id , elementable, onClose: () => onActiveElement(''), onChangeElementable,  }}
        {..._omit(elementProps[elementable_type], ['additional'])}
        {...{ bounds, onDelete, onTransform }}
        {...pageSize}
      />
      {elementProps[elementable_type]?.additional}
    </>
  );
}

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <Element {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);